import { Mui } from "@osu/react-ui";
import { Fragment } from "react";
import DataGrid from "./DataGrid";
import Toolbar from "./Renders/Toolbar";
import { useSelector } from "react-redux";
import { selectIsAdmin, selectIsUser } from "../../../services/authorization/slices";

const tableStyles = (theme) => {
  return {
    marginBottom: theme.spacing(5),
    [` .${Mui.tableHeadClasses.root} .${Mui.tableCellClasses.root}`]: {
      ...theme.typography.subtitle2,
    },
    [` .${Mui.tableBodyClasses.root} .${Mui.tableCellClasses.root} .${Mui.linkClasses.root}`]:
      {
        color: theme.palette.primary.main,
      },
  };
};

function Table({ year, id, type, ...rest }) {
  const isAdmin = useSelector(selectIsAdmin);
  const isStandardUser = useSelector(selectIsUser);
  const canSeeTable = isAdmin || isStandardUser
  return (
    <Fragment>
      <Mui.TableContainer sx={tableStyles} component={Mui.Paper}>
         {canSeeTable && <DataGrid
          id={id}
          year={year}
          type={type}
          isAdmin={isAdmin}
          slots={{ toolbar: Toolbar }}
          showToolbar
          {...rest}
         />}
      </Mui.TableContainer>
    </Fragment>
  );
}

export default Table;